import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "L\xEBtzebuergesch",
  code: "lb",
  messages: {
    alert: {
      close: "Zoumaachen"
    },
    authForm: {
      hidePassword: "Passwuert verstoppen",
      showPassword: "Passwuert uweisen",
      submit: "Fortsch\xE9cken"
    },
    banner: {
      close: "Zoumaachen"
    },
    calendar: {
      nextMonth: "N\xE4chste Mount",
      nextYear: "N\xE4chst Joer",
      prevMonth: "Virege Mount",
      prevYear: "Viregt Joer"
    },
    carousel: {
      dots: "Wielt Dia fir ze weisen",
      goto: "Gitt op d'Slide {Slide}",
      next: "N\xE4ch.",
      prev: "Pr\xE4z."
    },
    chatPrompt: {
      placeholder: "Tippt hei \xC4re Message..."
    },
    chatPromptSubmit: {
      label: "Prompt sch\xE9cken"
    },
    colorMode: {
      dark: "Donkel",
      light: "Liicht",
      switchToDark: "Op de Donkelmodus wiesselen",
      switchToLight: "Op de Liichtmodus wiesselen",
      system: "System"
    },
    commandPalette: {
      back: "Zr\xE9ck",
      close: "Zoumaachen",
      noData: "Keng Donn\xE9e\xEBn",
      noMatch: "Keng entspriechend Donn\xE9e\xEBn",
      placeholder: "Tippt e Befeel oder sicht..."
    },
    contentSearch: {
      links: "Linken",
      theme: "Thema"
    },
    contentSearchButton: {
      label: "Sichen..."
    },
    contentToc: {
      title: "Op d\xEBser S\xE4it"
    },
    dashboardSearch: {
      theme: "Thema"
    },
    dashboardSearchButton: {
      label: "Sichen..."
    },
    dashboardSidebarCollapse: {
      collapse: "Sidebar zouklappen",
      expand: "Sidebar opklappen"
    },
    dashboardSidebarToggle: {
      close: "Sidebar zoumaachen",
      open: "Sidebar opmaachen"
    },
    error: {
      clear: "Zr\xE9ck op d'Starts\xE4it"
    },
    fileUpload: {
      removeFile: "{filename} ewechhuelen"
    },
    header: {
      close: "Men\xFC zoumaachen",
      open: "Men\xFC opmaachen"
    },
    inputMenu: {
      create: '"{label}" erstellen',
      noData: "Keng Donn\xE9e\xEBn",
      noMatch: "Keng entspriechend Donn\xE9e\xEBn"
    },
    inputNumber: {
      decrement: "Dekrement\xE9ieren",
      increment: "Inkrement\xE9ieren"
    },
    modal: {
      close: "Zoumaachen"
    },
    pricingTable: {
      caption: "Vergl\xE4ich vun de Pr\xE4ispl\xE4ng"
    },
    prose: {
      codeCollapse: {
        closeText: "Zouklappen",
        name: "code",
        openText: "Opklappen"
      },
      collapsible: {
        closeText: "Verstoppen",
        name: "eegenschaften",
        openText: "Uweisen"
      },
      pre: {
        copy: "Code an d'Zw\xEBschsp\xE4icher kop\xE9ieren"
      }
    },
    selectMenu: {
      create: '"{label}" erstellen',
      noData: "Keng Donn\xE9e\xEBn",
      noMatch: "Keng entspriechend Donn\xE9e\xEBn",
      search: "Sichen.."
    },
    slideover: {
      close: "Zoumaachen"
    },
    table: {
      noData: "Keng Donn\xE9e\xEBn"
    },
    toast: {
      close: "Zoumaachen"
    }
  }
});
